import http from '@/http/aisea/axios'
const resource = "/enterprises/admins/accounts/invites";

export default {

  search() {
    return http.get(`${resource}`);
  },

};
